import type { IUptimeData } from '@/data';
interface HeatmapCellData {
  date: string;
  hour: number;
  status: 'up' | 'slow' | 'down' | 'no-data';
  avgResponseTime: number;
  count: number;
  incidents: IUptimeData[];
}
interface ISummaryProps {
  heatmapData: HeatmapCellData[][];
}
export const Summary: React.FC<ISummaryProps> = ({
  heatmapData
}) => {
  const totalCells = heatmapData.flat().filter(cell => cell.count > 0).length;
  const upCells = heatmapData.flat().filter(cell => cell.status === 'up').length;
  const slowCells = heatmapData.flat().filter(cell => cell.status === 'slow').length;
  const downCells = heatmapData.flat().filter(cell => cell.status === 'down').length;
  const uptime = totalCells > 0 ? (upCells + slowCells * 0.5) / totalCells * 100 : 0;
  return <div className='mt-3 grid grid-cols-2 gap-4 *:flex *:items-end *:justify-between *:rounded-lg *:border *:border-foreground/10 *:bg-background-deep/30 *:px-3 *:py-2 md:grid-cols-4'>
      <div>
        <p className='text-foreground/60 text-sm'>Uptime</p>
        <p className='font-bold text-2xl text-foreground'>
          {uptime.toFixed(1)}%
        </p>
      </div>
      <div>
        <p className='text-foreground/60 text-sm'>Up Periods</p>
        <p className='font-bold text-2xl text-foreground'>{upCells}</p>
      </div>
      <div>
        <p className='text-foreground/60 text-sm'>Slow Periods</p>
        <p className='font-bold text-2xl text-foreground'>{slowCells}</p>
      </div>
      <div>
        <p className='text-foreground/60 text-sm'>Down Periods</p>
        <p className='font-bold text-2xl text-foreground'>{downCells}</p>
      </div>
    </div>;
};